module.exports = __webpack_public_path__ + "static/media/Bootstrap.1bd75ecd.png";